import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const FiverrIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    viewBox="0 0 24 24"
    fill={theme.colors[color]}
  >
    <path d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12m-6.7 6.36H14.15v-6.974h-3.016v6.974h-3.17v-6.974H6.166v-2.58h1.797v-.784c0-2.044 1.547-3.439 3.847-3.439h2.34v2.58h-1.817c-.735 0-1.2.4-1.2 1.05v.593h6.168z" />
  </svg>
);
FiverrIcon.id = 'FiverrIcon';
FiverrIcon.displayName = 'FiverrIcon';
export default FiverrIcon;
